













































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors";
import BaseMixin from "@/mixins/BaseMixin";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import NavigationTabs from "@/components/Settings/Events/EventDetails/NavigationTabs.vue";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import swal from "sweetalert";
import { IAppointment, IEvent, IVenue } from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    NavigationTabs,
    InfoButton,
    BackButton,
    DangerButton,
    DatePicker,
    Error404
  }
})
export default class EventAppointmentDetails extends Mixins(
  FormErrorsMixin,
  BaseMixin
) {
  public loading = false;
  public updating = false;
  public validatedInputs = ["starts_at", "ends_at", "venue_id"];
  private noDataExist = false;
  private dateFormat = "DD.MM.YYYY";
  private timeFormat = "HH:mm";
  private date = "2020-01-01";
  private startTime: Date | null = null;
  private endTime: Date | null = null;
  private venues: Array<IVenue> = [];
  private selectedEvent: IEvent = {
    name: null
  };
  private selectedEventId: string | null = null;
  private selectedEventAppointmentId: string | null = null;
  private selectedEventAppointment: IAppointment = {
    starts_at: null,
    ends_at: null,
    venue_id: null
  };

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedEventId = vm.$route.params.event_id;
      vm.selectedEventAppointmentId = vm.$route.params.appointment_id;

      // Get Event
      if (
        typeof vm.selectedEventId !== "undefined" &&
        vm.selectedEventId !== null
      ) {
        vm.getEvent(() => {
          //
        });
      }

      // Get Event Appointment
      if (
        typeof vm.selectedEventAppointmentId !== "undefined" &&
        vm.selectedEventAppointmentId !== null
      ) {
        if (vm.$route.query.event_appointment_created === "true") {
          swal("Success!", "The appointment was created.", "success").then(
            () => {
              window.history.pushState(
                {},
                document.title,
                window.location.pathname
              );
            }
          );
        }
        vm.getEventAppointment(() => {
          //
        });
      }

      // Get Venues
      vm.getVenues(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    // Get Event
    if (
      typeof this.selectedEventId !== "undefined" &&
      this.selectedEventId !== null
    ) {
      this.getEvent(() => {
        //
      });
    }

    // Get Event Appointment
    if (
      typeof this.selectedEventAppointmentId !== "undefined" &&
      this.selectedEventAppointmentId !== null
    ) {
      this.getEventAppointment(() => {
        //
      });
    }

    // Get Venues
    this.getVenues(() => {
      //
    });
    next();
  }

  private createOrUpdateAppointment(): void {
    if (this.selectedEventAppointmentId == null) {
      this.createEventAppointment();
    } else {
      this.updateEventAppointment();
    }
  }

  private getEvent(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedEvent = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getEventAppointment(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" +
        this.selectedEventId +
        "/appointments/" +
        this.selectedEventAppointmentId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        if (response.data.data.venue && response.data.data.venue.id) {
          this.selectedEventAppointment.venue_id = response.data.data.venue.id;
        }
        if (response.data.data.starts_at && response.data.data.ends_at) {
          this.date = this.$moment(response.data.data.starts_at).format(
            this.dateFormat
          );
          this.startTime = this.$moment(response.data.data.starts_at).format(
            this.timeFormat
          );
          this.endTime = this.$moment(response.data.data.ends_at).format(
            this.timeFormat
          );
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateEventAppointment(): void {
    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" +
        this.selectedEventId +
        "/appointments/" +
        this.selectedEventAppointmentId
    );

    Api()
      .put(endpoint, this.selectedEventAppointment)
      .then((response: AxiosResponse) => {
        this.selectedEventAppointmentId = response.data.data.id;
        this.getEventAppointment();
      })
      .catch((error: any) => {
        console.log(error);
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private createEventAppointment(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/appointments"
    );

    Api()
      .post(endpoint, this.selectedEventAppointment)
      .then((response: AxiosResponse) => {
        this.selectedEventAppointmentId = response.data.data.id;
        this.$router.push({
          name: "EventAppointmentDetails",
          params: {
            event_id: `${this.selectedEventId}`,
            appointment_id: `${this.selectedEventAppointmentId}`
          },
          query: { event_appointment_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteEventAppointment(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The appointment will be deleted and will not be able to use it",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "events/" +
            this.selectedEventId +
            "/appointments/" +
            this.selectedEventAppointmentId
        );

        Api()
          .delete(endpoint)
          .then((response: AxiosResponse) => {
            console.log(response.status);
            this.$router.push({
              name: "EventAppointments",
              query: { event_appointment_deleted: "true" }
            });
          })
          .catch((error: any) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete event appointments.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getVenues(successCallback?: any): void {
    this.loading = true;
    this.venues = [];
    const endpoint: string = this.$partnerEndpoint("venues");

    Api()
      .get(endpoint, {
        params: {
          page: 1,
          search: ""
        }
      })
      .then((response: AxiosResponse) => {
        this.venues = response.data.data;
        if (
          this.selectedEventAppointment.venue_id === null &&
          response.data.data.length
        ) {
          this.selectedEventAppointment.venue_id = response.data.data[0].id;
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @Watch("date")
  dateChanged(state: Date): void {
    this.selectedEventAppointment.starts_at = `${this.convertDate(state)} ${
      this.startTime
    }:00`;
    this.selectedEventAppointment.ends_at = `${this.convertDate(state)} ${
      this.endTime
    }:00`;
  }

  @Watch("startTime")
  startTimeChanged(state: Date): void {
    this.selectedEventAppointment.starts_at = `${this.convertDate(
      this.date
    )} ${state}:00`;
  }

  @Watch("endTime")
  endTimeChanged(state: Date): void {
    this.selectedEventAppointment.ends_at = `${this.convertDate(
      this.date
    )} ${state}:00`;
  }
}
